import { AvailableMentorsDTO } from '@shared/clientTypes/DTOs/MentorsDTO';

import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export const getAvailableMentors: ApiDescription = {
  endpoint: '/integrations/mentors',
  method: RequestsMethod.Get,
};

export type GetAvailableMentors = ApiData<
  {
    page?: number;
    limit?: number;
    search?: string;
    universities?: string[];
    majors?: string[];
    statuses?: string[];
    degreeType?: string;
    onlyAvailable?: boolean;
    sortBy?: 'name' | 'capacity' | 'freeCapacity' | 'createdAt';
    sortOrder?: 'asc' | 'desc';
  },
  AvailableMentorsDTO
>;
